//@ts-check
import React from 'react';
import PublicLinkContext from './PublicLinkContext';
/**
 * @type {import("./types").usePublicLinkHook}
 */

var usePublicLink = function usePublicLink() {
  var state = React.useContext(PublicLinkContext);
  return state;
};

export default usePublicLink;